// SERVER ONLY ENVIRONMENT VARIABLES

export const IS_NODE_ENV_DEV = process.env.NODE_ENV === 'development';

export const INDI_API_HOST = process.env.INDI_API_HOST;

export const REDIS_HOST = process.env.REDIS_HOST;

export const INDI_MIDDLEWARE_HOST = process.env.INDI_MIDDLEWARE_HOST;

// Dev Utils
export const SHOW_HIDDEN_MENU = process.env.SHOW_HIDDEN_MENU === 'true';
export const X_INTERNAL_IP_SECRET = process.env.X_INTERNAL_IP_SECRET;
export const INDI_API_HOST_TEMPLATE = process.env.INDI_API_HOST_TEMPLATE;

export const SSO_API_KEY = process.env.SSO_API_KEY;
